export default "__VITE_ASSET__xMnAZ9ax__"